import { ActivityScoresDataType } from "../../types"
import RadioGroupWithLabel from "@/shared/inputs/RadioGroupWithLabel"

const FormSectionOne = () => {

  return (
    <>
      <RadioGroupWithLabel<ActivityScoresDataType> 
        fieldTitle="Website Promotion Priority" 
        nameInSchema="website_promotion_priority" 
        data={[{title: "Always", score: 100}, {title: "Sometimes", score: 50}, {title: "Never", score: 0}]}
      />
      <RadioGroupWithLabel<ActivityScoresDataType> 
        fieldTitle="Industry Trends Sensitivity" 
        nameInSchema="industry_trends_sensitivity" 
        data={[{title: "High", score: 100}, {title: "Medium", score: 50}, {title: "Low", score: 0}]}
      />
      <RadioGroupWithLabel<ActivityScoresDataType> 
        fieldTitle="Engagement vs Conversion Trade off" 
        nameInSchema="engagement_vs_conversion_tradeoff" 
        data={[{title: "Engagement Focused", score: 100}, {title: "Balanced", score: 50}, {title: "Conversion Focused", score: 0}]}
      />
      <RadioGroupWithLabel<ActivityScoresDataType> 
        fieldTitle="Platform Specific Adaptation" 
        nameInSchema="platform_specific_adaptation" 
        data={[{title: "Optimize automatically", score: 100}, {title: "Strict Guideline", score: 50}]}
      />
    </>
  )
}

export default FormSectionOne;
